import React from 'react';
import { INavbarItem } from '@models/interfaces/navigation.interface';
import BottomNavbarItem from '@components/navigation/BottomNavbarItem';
import { matchPath, useLocation } from 'react-router-dom';

export interface BottomNavbarProps {
  items: INavbarItem[];
  setItems: React.Dispatch<React.SetStateAction<INavbarItem[]>>;
  onClickNavigation: (key: string) => void;
  showAccountDropdown: boolean;
  setShowAccountDropdown: React.Dispatch<React.SetStateAction<boolean>>;
  subjectListLength: number;
}

const BottomNavbar = (props: BottomNavbarProps) => {
  const location = useLocation();

  function handleClick(e: React.FormEvent, item: INavbarItem) {
    if (
      item.key != 'account' &&
      !props.showAccountDropdown &&
      matchPath('/:subjectId/099-03/:delayedStartDate', location.pathname)
    )
      return false; // prevent navigation when on showing error 099-03 page

    e.preventDefault();

    const tmpItems = JSON.parse(JSON.stringify(props.items));
    for (let i = 0; i < tmpItems.length; i++) {
      tmpItems[i].selected = tmpItems[i].key === item.key;
    }
    props.setItems(tmpItems);

    if (item.key === 'account') {
      props.setShowAccountDropdown(true);
    } else {
      if (props.subjectListLength === 0) {
        if (item.key !== 'geniesmart') {
          return;
        }
      }
      if (props.showAccountDropdown) {
        props.setShowAccountDropdown(false);
      }
      props.onClickNavigation(item.key);
    }
  }

  return (
    <div
      id={'bottom-navbar'}
      className={
        'fixed bottom-0 left-0 w-full max-md:py-5 md:py-3 px-2 max-md:pt-2 max-md:pb-2.5 z-100 bg-neutral-whiteboard'
      }
    >
      <div
        className={'flex w-full justify-around bottom-navbar-item-container'}
      >
        {props.items
          .filter(item => item.showInBottomNavbar && !item.hide)
          .map(item => {
            return (
              <div
                onClick={event => handleClick(event, item)}
                className={
                  'flex-initial max-md:w-16 md:w-auto menu-' + item.key
                }
                key={`${item.key}-${item.selected}`}
              >
                <BottomNavbarItem {...item} />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default BottomNavbar;
